<template>
  <v-container fluid class="pl-15 pr-10">
    <AuthCtrl :parm_step="10"></AuthCtrl>
    <div class="d-flex justify-center mt-5">
      <v-stepper flat class="d-flex" style="background: transparent">
        <v-stepper-step
          step="1"
          complete
          class="flex-column pr-0"
          color="#2CD8C5"
        >
          <v-btn
            flat
            class="mt-5 text-capitalize font-weight-bold titleText--text"
            small
            depressed
            @click="onnextclick(), goTo('sessionalitysetting')"
            >Seasonality & Decay</v-btn
          >
        </v-stepper-step>
        <div class="border__dashed"></div>
        <v-stepper-step
          step="2"
          complete
          class="flex-column px-0"
          color="#2CD8C5"
        >
          <v-btn
            small
            depressed
            class="mt-5 ml-2 text-capitalize font-weight-bold titleText--text"
            @click="onnextclick(), goTo('newvariablecreation')"
            >New variable creation</v-btn
          >
        </v-stepper-step>
        <div class="border__dashed"></div>
        <v-stepper-step
          step="3"
          complete
          class="d-flex flex-column pl-0"
          color="#2CD8C5"
        >
          <v-btn
            depressed
            small
            color="white"
            style="
              box-shadow: 0px 4px 15px rgba(80, 93, 111, 0.1);
              border-radius: 10px;
            "
            class="mt-5 ml-2 text-capitalize font-weight-bold titleText--text"
            >Transformation</v-btn
          >
        </v-stepper-step>
      </v-stepper>
    </div>
    <div class="d-flex justify-space-between align-center mb-5">
      <v-row class="d-flex align-center">
        <v-col cols="9">
          <v-btn-toggle mandatory borderless color="blue">
            <v-btn height="36" small exact @click="onclickbtn(1)">
              <span class="text-capitalize font-weight-bold titleText--text"
                >Parameter</span
              >
            </v-btn>
            <v-btn height="36" small exact @click="onclickbtn(3)">
              <span class="text-capitalize font-weight-bold titleText--text"
                >Processed data</span
              >
            </v-btn>
          </v-btn-toggle></v-col
        >
        <v-col cols="3" v-if="bttype === 3">
          <v-select
            class="ml-5"
            solo
            flat
            dense
            hide-details
            style="border-radius: 8px; border: 2px solid #f3f5f8"
            v-model="dataregionSelected"
            :items="dataregion"
            @change="callRegionChangeEvent()"
            v-if="this.isregiosubnnational"
          ></v-select
        ></v-col>
      </v-row>
    </div>
    <div v-if="bttype === 1">
      <v-card flat class="custom-shadow">
        <v-card-text>
          <v-row>
            <v-col cols="7">
             
              <v-card flat color="rgb(243, 245, 248, .4)" rounded >
                <v-card-title>
                  <h3 class="titleText--text">Variables encoders and transformers</h3>
                </v-card-title>
                <v-card-text>
                  <div
                    style="
                      background: rgb(243, 245, 248, 0.4) !important;
                      
                    "
                  >
                    <v-simple-table fixed-header height="600" sortable="true">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th
                              style="background: rgb(243, 245, 248)"
                              class="
                                text-center
                                titleText--text
                                font-weight-bold
                              "
                            >
                            <div class="d-flex">
                              <span class="titleText--text">Variable</span>
                              <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon  v-bind="attrs" size="medium"
                                  v-on="on" color="blue" class="ml-1">mdi-information-outline</v-icon>
                                </template>
                                <span> Variable </span>
                              </v-tooltip>
                            </div>
                            </th>
                            <th
                              style="background: rgb(243, 245, 248)"
                              class="
                                text-center
                                titleText--text
                                font-weight-bold
                              "
                            >
                            <div class="d-flex">
                              <span class="titleText--text">Linear</span>
                              <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon  v-bind="attrs" size="medium"
                                  v-on="on" color="blue" class="ml-1">mdi-information-outline</v-icon>
                                </template>
                                <span> Linear </span>
                              </v-tooltip>
                            </div>
                            </th>
                            <th
                              style="background: rgb(243, 245, 248)"
                              class="
                                text-center
                                titleText--text
                                font-weight-bold
                              "
                            >
                            <div class="d-flex">
                              <span class="titleText--text">Power</span>
                              <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon  v-bind="attrs" size="medium"
                                  v-on="on" color="blue" class="ml-1">mdi-information-outline</v-icon>
                                </template>
                                <span> Power </span>
                              </v-tooltip>
                            </div>
                            </th>
                            <th
                              style="background: rgb(243, 245, 248)"
                              class="
                                text-center
                                titleText--text
                                font-weight-bold
                              "
                            >
                            <div class="d-flex">
                              <span class="titleText--text">Lag</span>
                              <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon  v-bind="attrs" size="medium"
                                  v-on="on" color="blue" class="ml-1">mdi-information-outline</v-icon>
                                </template>
                                <span> Lag </span>
                              </v-tooltip>
                            </div>
                            </th>
                            <th
                              style="background: rgb(243, 245, 248)"
                              class="
                                text-center
                                titleText--text
                                font-weight-bold
                              "
                            >
                            <div class="d-flex">
                              <span class="titleText--text">Log</span>
                              <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon  v-bind="attrs" size="medium"
                                  v-on="on" color="blue" class="ml-1">mdi-information-outline</v-icon>
                                </template>
                                <span> Log </span>
                              </v-tooltip>
                            </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in transformvarlistNew" :key="item">
                            <td
                              style="background: rgb(243, 245, 248, 0.4)"
                              class="text-left titleText--text font-weight-bold"
                            >
                              {{ item.variable }}
                            </td>
                            <td
                              style="background: rgb(243, 245, 248, 0.4)"
                              class="text-center"
                            >
                              <div style="width: 90px; float: center;">
                                <v-edit-dialog
                                  :return-value.sync="item.Linear"
                                  @save="
                                    savenew(
                                      item.Linear,
                                      item.variable,
                                      'Linear'
                                    )
                                  "
                                  @cancel="cancel"
                                  @open="open"
                                  @close="close"
                                  large
                                >
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <span class="titleText--text font-weight-bold" v-bind="attrs" v-on="on">
                                        <span>{{ item.Linear }}</span>
                                      </span>
                                    </template>
                                    <span>Edit</span>
                                  </v-tooltip>
                                  <template v-slot:input>
                                    <v-text-field
                                      @keypress="IsNumber($event)"
                                      v-model="item.Linear"
                                      label="Edit"
                                      single-line
                                      class="text-center"
                                    ></v-text-field>
                                  </template>
                                </v-edit-dialog>
                              </div>
                            </td>
                            <td style="background: rgb(243, 245, 248, 0.4)" class="text-center">
                              <div style="width: 90px; float: center">
                                <v-edit-dialog
                                  :return-value.sync="item.PowerFunctoin"
                                  @save="
                                    savenew(
                                      item.PowerFunctoin,
                                      item.variable,
                                      'power'
                                    )
                                  "
                                  @cancel="cancel"
                                  @open="open"
                                  @close="close"
                                  large
                                >
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <span class="titleText--text font-weight-bold" v-bind="attrs" v-on="on">
                                        <span>{{ item.PowerFunctoin }}</span>
                                      </span>
                                    </template>
                                    <span>Edit</span>
                                  </v-tooltip>
                                  <template v-slot:input>
                                    <v-text-field
                                      @keypress="IsNumber($event)"
                                      v-model="item.PowerFunctoin"
                                      label="Edit"
                                      single-line
                                      class="text-center"
                                    ></v-text-field>
                                  </template>
                                </v-edit-dialog>
                              </div>
                            </td>
                            <td style="background: rgb(243, 245, 248, 0.4)" class="text-center">
                              <div style="width: 90px; float: center">
                                <v-edit-dialog
                                  :return-value.sync="item.Lag"
                                  @cancel="cancel"
                                  @open="open"
                                  @close="close"
                                  @save="
                                    savenew(item.Lag, item.variable, 'lag')
                                  "
                                  large
                                >
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <span class="titleText--text font-weight-bold" v-bind="attrs" v-on="on">
                                        <span>{{ item.Lag }}</span>
                                      </span>
                                    </template>
                                    <span>Edit</span>
                                  </v-tooltip>
                                  <template v-slot:input>
                                    <v-row style="margin-top: 20px">
                                      <v-col>
                                        <v-select
                                          v-model="item.Lag"
                                          :items="LagItems"
                                          label="Lag"
                                          dense
                                        ></v-select>
                                      </v-col>
                                    </v-row>
                                  </template>
                                </v-edit-dialog>
                              </div>
                            </td>
                            <td
                              style="background: rgb(243, 245, 248, 0.4)"
                              class="text-center"
                            >
                              <v-simple-checkbox
                                v-model="item.Log"
                                color="blue"
                                rounded
                                on-icon="mdi-checkbox-marked-circle"
                                off-icon="mdi-checkbox-blank-circle-outline"
                                style="border-radius: 50px"
                                @click="changelognew(item.Log, item.variable, 'log')"
                              ></v-simple-checkbox>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="5">
              <CtrlVarstandardization
                ref="ctrlvarstandardization"
              ></CtrlVarstandardization>
            </v-col>
          </v-row>
          <ctrSplitVariabledata
            ref="refctrSplitVariabledata"
            @onAddVariable="showSplitVariabledilog()"
            class="mt-5"
          />
        </v-card-text>
      </v-card>
    </div>
    <div v-if="bttype === 3">
      <CtrlVariableTransformgraphview
        ref="refgraphview"
        :title="dataregionSelected"
        :regionlist="listofregion"
      ></CtrlVariableTransformgraphview>
      <CtrlVariableTransformgridview
        ref="ctrlVariableTransformgridview"
        :title="dataregionSelected"
        class="mt-5"
      ></CtrlVariableTransformgridview>
    </div>
    <ctrSplitVariable ref="refctrlsplitvariable"></ctrSplitVariable>
  </v-container>
</template>

<script>
import AuthCtrl from "../../../components/AuthAction.vue";

import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import apifactory from "../api";
import globalclass from "../../../global/globalvar";
//import CtrlNavButton from "../../../components/CtrbuttonSaveAndNext.vue";
import CtrlVariableTransformgridview from "../views/ctrlVariableTransformgridview.vue";
import CtrlVariableTransformgraphview from "../views/ctrlVariableTransformationgraphview.vue";
import CtrlVarstandardization from "../views/ctrlVarstandardization.vue";
import ctrSplitVariable from "../views/ctrSplitVariable.vue";
import ctrSplitVariabledata from "../views/ctrSplitVariabledata.vue";
Vue.use(VueAxios, axios);

export default {
  components: {
    AuthCtrl,
    //  CtrlNavButton,
    CtrlVariableTransformgridview,
    CtrlVariableTransformgraphview,
    CtrlVarstandardization,
    ctrSplitVariable,
    ctrSplitVariabledata,
  },
  data: () => ({
    bttype: 1,
    stepidCurrent: globalclass.PARAM_Step_MDP_VT,
    stepidPrevious: globalclass.PARAM_Step_MDP_AS,
    currentprojectid: "0",
    currentloginuser: "9",
    prevstepQueryStringParm: [],
    prevstepQueryStringParmUrl: [],
    prevstepQueryStringParmUrlfordata: [],
    tbdurl: [],

    transformvarlist: [],
    transformvarlistsaved: [],
    transformvarlistNew: [],
    transformvarlistfordb: [],

    strtemp: null,

    tblheaders: [
      {
        text: "Variables",
        value: "variable",
      },
      {
        text: "Linear",
        value: "Linear",
      },
      {
        text: "Log",
        value: "Log",
      },
      {
        text: "PowerFunctoin",
        value: "PowerFunctoin",
      },
    ],
    LagItems: ["0", "1", "2", "3"],
    dataregion: [],
    dataregionSelected: [],
    isregiosubnnational: false,
    splitvardialog: false,
  }),

  methods: {
    goTo(url) {
      this.$router.push(url);
    },
    RefreshSplitDataView() {
      this.$refs.refctrSplitVariabledata.CallOnload();
    },
    showSplitVariabledilog() {
      this.$refs.refctrlsplitvariable.CallOnload("md");
    },
    savenew(txtval, variablename, functionname) {
      this.saveInDBNew(
        this.dataregionSelected,
        variablename,
        functionname,
        txtval
      );
    },
    saveInDBNew(varregion, variablename, functionname, paramval) {
      apifactory
        .api_save_transformationvariable(
          varregion,
          variablename,
          functionname,
          paramval
        )
        .then((res) => {
          if (res.status != 200) {
            //this.countryList = null;
          } else {
            this.savestepparameter();
          }
          this.getalltransform_varlist();
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    changelognew(varval, variablename, functionname) {
      if (varval == true) {
        this.saveInDBNew(
          this.dataregionSelected,
          variablename,
          functionname,
          1
        );
      } else {
        this.saveInDBNew(
          this.dataregionSelected,
          variablename,
          functionname,
          0
        );
      }
    },
    save(txtval, objdata, varid, headerid) {
      for (var i = 0; i < this.transformvarlistNew.length; i++) {
        if (this.transformvarlistNew[i].id === varid) {
          //alert( this.dummyVarListforAdd[i][varkey]);
          //this.dummyVarListforAdd[i].d1_dummy = event;
          if (headerid === 3) {
            this.transformvarlistNew[i]["Linear"] = 0;
          }
          if (headerid === 1) {
            this.transformvarlistNew[i]["PowerFunctoin"] = 0;
          }

          this.transformvarlistNew[i]["transformation"] = headerid;
          this.transformvarlistNew[i]["p1"] = txtval;
          this.transformvarlistNew[i]["isfordb"] = 1;

          break;
        }
      }
    },
    changelog(varid, varval) {
      // alert(varid);
      //alert(varval);
      for (var i = 0; i < this.transformvarlistNew.length; i++) {
        if (this.transformvarlistNew[i].id === varid) {
          this.transformvarlistNew[i]["Log"] = varval;
          this.transformvarlistNew[i]["transformation"] = 2;
          //this.transformvarlistNew[i]["p1"] = 0;
          this.transformvarlistNew[i]["isfordb"] = 1;
          break;
        }
      }
    },
    IsNumber(event) {
      if (!/\d/.test(event.key) && event.key !== ".")
        return event.preventDefault();
    },
    onclickbtn(varbttype) {
      this.bttype = varbttype;
    },

    onnextclick() {
      this.gettheprojectid();
      this.savestepparameter();
    },
    savestepparameter() {
      apifactory
        .addParameterByStepsbyurl(
          `step=12&test=1&project=${this.currentprojectid}`
        )
        .then(() => this.savestep5());
    },
    savestep5() {
      apifactory.call_save_step5();
    },
    
    savedataInDB() {
      this.transformvarlistfordb = [];
      for (var i = 0; i < this.transformvarlistNew.length; i++) {
        if (this.transformvarlistNew[i].isfordb === 1) {
          let obj = new Object();
          obj.variable = this.transformvarlistNew[i]["variable"];
          obj.transformation = this.transformvarlistNew[i]["transformation"];
          obj.p1 = this.transformvarlistNew[i]["p1"];
          obj.p2 = this.transformvarlistNew[i]["p2"];

          this.transformvarlistfordb.push(obj);
        }
      }
      apifactory
        .variableTransformation_save(
          this.currentprojectid,
          JSON.stringify(this.transformvarlistfordb)
        )
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            this.savestepparameter();
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    gettheprojectid() {
      this.currentprojectid = apifactory.getcurrentproject();
    },
    getParametrOfPrvStep() {
      this.prevstepQueryStringParm = "";

      apifactory
        .gettheParameterByProjectStep(this.stepidPrevious)
        .then((res) => {
          if (res.status != 200) {
            this.prevstepQueryStringParm = "";
            // alert(this.processdataitems.length);
          } else {
            this.prevstepQueryStringParm = res.data;

            let strurl = "";
            for (var k in this.prevstepQueryStringParm) {
              if (k != "step") {
                strurl =
                  strurl + k + "=" + this.prevstepQueryStringParm[k] + "&";
                // alert( this.prevstepQueryStringParm[k]);
              }
            }
            strurl = strurl.slice(0, -1);
            this.prevstepQueryStringParmUrl = strurl;
            this.prevstepQueryStringParmUrlfordata =
              "step=" + this.stepidCurrent + "&" + strurl;
            this.getalltransform_varlist();
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    getalltransform_varlist() {
      this.getalltransform_varlist_saved();
    },
     getalltransform_varlist_saved() {
      //alert("getalltransform_varlist_saved");
      this.transformvarlistsaved = [];
      apifactory
        .api_save_transformationvariable_getsavedvalues()
        .then((res) => {
          //alert("transformvarlistsaved" + JSON.stringify(res));
          if (res.status != 200) {
            this.transformvarlistsaved = [];
            // alert(this.processdataitems.length);
          } else {
            this.transformvarlistsaved = res.data;
            //alert("transformvarlistsaved" + JSON.stringify(res.data));

            this.getalltransform_varlist_main();
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    getalltransform_varlist_main() {
      this.transformvarlist = [];
      this.transformvarlistNew=[];
      /*
      this.transformvarlist= [];
    this.transformvarlistsaved= [];
    this.transformvarlistNew= [];
    this.transformvarlistfordb= [];*/
      apifactory
        .api_variableTransformation_GetVarlist()
        .then((res) => {
          if (res.status != 200) {
            this.transformvarlist = [];
            // alert(this.processdataitems.length);
          } else {
            this.transformvarlist = res.data.variable_list;
            //alert("getalltransform_varlist"+JSON.stringify(res.data));
            let index = 1;
            for (var k in this.transformvarlist) {
              //alert("function call "+JSON.stringify(this.getsavevalusforlist("Linear",this.transformvarlist[k])));
              //let varfilter=this.transformvarlistsaved.filter(a=>a.function == "Power");
              //alert("transformvarlistsaved===inner===" + JSON.stringify(varfilter));
              let tempobj = new Object();
              this.strtemp = this.strtemp + this.transformvarlist[k] + ",";
              tempobj.id = index;
              tempobj.variable = this.transformvarlist[k];
              tempobj.Linear = this.getsavevalusforlist("Linear",this.transformvarlist[k]);
              tempobj.PowerFunctoin = this.getsavevalusforlist("power",this.transformvarlist[k]);
              let newlogvalue= this.getsavevalusforlist("log",this.transformvarlist[k]);
              if(newlogvalue !=0){ tempobj["Log"] = true;}else{ tempobj["Log"] = false;}
             
              tempobj["transformation"] = "";
              tempobj["p1"] = 0;
              tempobj["p2"] = 0;
              tempobj["isfordb"] = 0;
              tempobj["Lag"] = this.getsavevalusforlist("lag",this.transformvarlist[k]);
              this.transformvarlistNew.push(tempobj);
              index = index + 1;
            }
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
   
     getsavevalusforlist(varfunction,varvariable) {
      // let varfilter=this.transformvarlistsaved.filter(a=>a.function == varfunction);
       //alert("getsavevalusforlist varfunction" + JSON.stringify(varfunction) + "=="+ JSON.stringify(varvariable) );
      //let result="";
      let resultdata=0;
      for (let e in this.transformvarlistsaved) {
        
        if (this.transformvarlistsaved[e].function == varfunction && this.transformvarlistsaved[e].variable == varvariable) {
          //result="OK";
          resultdata= this.transformvarlistsaved[e].param;
        }
        
        //alert("getsavevalusforlist=== "+JSON.stringify(result) +"=== function" + JSON.stringify(varfunction) +" & varvariable" + JSON.stringify(varvariable)+  "data:== "+ JSON.stringify(this.transformvarlistsaved[e]));
      }
      
      return JSON.stringify(resultdata);
      //return resultdata;
      //alert("transformvarlistsaved===inner===" + JSON.stringify(varfilter));
      //alert("transformvarlistsaved===inner===" + JSON.stringify(varvariable));
    },

    getprojectregions() {
      this.listofregion = [];
      apifactory.call_get_project_region_list().then((res) => {
        if (res.status != 200) {
          // return false;
        } else {
          if (res.data.length == 0) {
            this.isregiosubnnational = false;
            this.listofregion.push("national");
            this.dataregionSelected = this.listofregion[0];
          } else {
            this.isregiosubnnational = true;
            this.listofregion = res.data.filter((a) => a != "national");
            this.dataregionSelected = this.listofregion[0];
          }
          this.dataregion = this.listofregion;
          //alert('data:-'+this.listofregion.length);
        }
      });
    },
    callRegionChangeEvent() {
      
      if (this.bttype == 3) {
        this.$refs.refgraphview.refresh(this.dataregionSelected);
        this.$refs.ctrlVariableTransformgridview.refresh(
          this.dataregionSelected
        );
      }
    },
  },
  computed: {
   
  },
  mounted() {
    console.log('mounted parent')
    this.getprojectregions();
    this.getalltransform_varlist();
  },
};
</script>

<style scoped>
.txtnew {
  width: 40px !important;
}

.divtablecontent {
  width: 80px !important;
  text-align: center;
  align-content: center;
}

.header20 {
  width: 50px !important;
}

.header10 {
  width: 10px !important;
}

.redcolr {
  background-color: blue;
}

.v-data-table tbody tr:hover:not(.v-data-table__expanded__content) {
  background: #fff;
}
.customselectbox {
  padding-top: 10px !important;
  width: 80% !important;
}
.exppanel-header {
  height: 50px !important;
  background-color: white !important;
}

.border__dashed {
  border: 1px dashed #505d6f;
  opacity: 0.4;
  height: 0px;
  width: 100px;
  margin-top: 5%;
}
table td {
  border: none !important;
}

table thead,
table tr {
  border: none !important;
}
</style>
